import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CSSignal } from 'app/shared/models/data-studio.model';

@Component({
  selector: 'app-control-system-signals',
  templateUrl: './control-system-signals.component.html',
  styleUrls: ['./control-system-signals.component.scss'],
  standalone: false
})
export class ControlSystemSignalsComponent implements OnChanges {

  @Input() signals: CSSignal[];
  @Output() changeSignalsSelection = new EventEmitter<CSSignal[]>();

  allSignalsSelected = false;

  csSignals: CSSignal[];

  get totalSignals() {
    return this.signals?.length || 0;
  }
  get totalSignalsSelected() {
    return this.csSignals?.filter(signal => signal.checked).length || 0;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.signals?.currentValue) {
      this.csSignals = this.signals.map(({ displayName, dbName, deviceId, unit }) => ({ displayName, dbName, deviceId, unit, checked: false }))
    }
  }

  selectAllSignals() {
    this.allSignalsSelected = !this.allSignalsSelected;
    this.csSignals?.forEach(signal => {
      signal.checked = this.allSignalsSelected;
      return signal;
    });
    this.changeSignalsSelection.emit(this.csSignals?.filter(signal => signal.checked));
  }

  checkSelectedSignal({ checked }, signal) {
    signal.checked = checked;
    this.allSignalsSelected = this.csSignals?.every(signal => signal.checked);
    this.changeSignalsSelection.emit(this.csSignals?.filter(signal => signal.checked));
  }

}
